import { ofTypeForTag } from './unionize'
import * as uz from 'unionize'

const unionizeTagOptions = {
  tag: 'type' as 'type'
}
const ofType = ofTypeForTag('type')

const unionize = <Record extends uz.MultiValueRec>(record: Record) => uz.unionize(record, unionizeTagOptions)

export { UnionOf } from 'unionize'
export { ofType, unionize }



// WEBPACK FOOTER //
// ./src/framework/unionize-usage.ts